import { action, thunk } from 'easy-peasy';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../../helper/firebase.config';

const authModel = {
  user: null,
  userId: null,
  loading: true,
  credits: null,
  subscription: null,
  billingCountry: null,
  isFreePlan: null,

  setUser: action((state, payload) => {
    state.user = payload;
  }),

  setUserId: action((state, payload) => {
    state.userId = payload;
  }),

  setLoading: action((state, payload) => {
    state.loading = payload;
  }),

  setCredits: action((state, payload) => {
    state.credits = payload;
  }),

  setSubscription: action((state, payload) => {
    state.subscription = payload;
  }),

  setBillingCountry: action((state, payload) => {
    state.billingCountry = payload;
  }),

  setIsFreePlan: action((state, payload) => {
    state.isFreePlan = payload;
  }),

  // initialize Firebase auth listener
  initAuthListener: thunk((actions) => {
    onAuthStateChanged(auth, (user) => {
      actions.setUser(user);
      actions.setUserId(user?.uid);
      actions.setLoading(false);
    });
  })
};

export default authModel;
